import { render, staticRenderFns } from "./RedemptionHistory.vue?vue&type=template&id=228cc751"
import script from "./RedemptionHistory.vue?vue&type=script&lang=ts"
export * from "./RedemptionHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports